"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_WEBP_SUPPORT = exports.SET_USER = exports.SET_URLS = exports.SET_TOKEN_PARAMS = exports.SET_TOKEN = exports.SET_THEME = exports.RESET_USER_CORE = exports.RESET_ALL_CORE = void 0;
const SET_USER = exports.SET_USER = 'SET_USER';
const SET_TOKEN = exports.SET_TOKEN = 'SET_TOKEN';
const SET_TOKEN_PARAMS = exports.SET_TOKEN_PARAMS = 'SET_TOKEN_PARAMS';
const SET_THEME = exports.SET_THEME = 'SET_THEME';
const SET_URLS = exports.SET_URLS = 'SET_URLS';
const SET_WEBP_SUPPORT = exports.SET_WEBP_SUPPORT = 'SET_WEBP_SUPPORT';
const RESET_USER_CORE = exports.RESET_USER_CORE = 'RESET_USER_CORE';
const RESET_ALL_CORE = exports.RESET_ALL_CORE = 'RESET_ALL_CORE';